import cx from "classnames";

import TextEllipsis from "ds/components/TextEllipsis";
import Typography from "ds/components/Typography";
import { getCommitLabel } from "utils/commit";
import { Stack } from "types/generated";
import TableCellEmpty from "ds/components/Table/Row/CellEmpty";

import styles from "./styles.module.css";

type StacksTableCommitCellBlobContentProps = {
  stack: Stack;
};

// Blob Storage has no VCS host, so the commit is rendered as plain text. "Outdated"
// means the HEAD pointer in the bucket has moved past the stack's tracked commit.
const StacksTableCommitCellBlobContent = ({ stack }: StacksTableCommitCellBlobContentProps) => {
  const { provider, trackedCommit, trackedBranchHead, trackedCommitSetBy } = stack;

  if (!trackedCommit) return <TableCellEmpty />;

  const trackedCommitIsOutdated =
    trackedCommit && trackedBranchHead && trackedCommit.hash !== trackedBranchHead.hash;

  const commitDetails = (trackedCommitSetBy || trackedCommitIsOutdated) && (
    <>
      <br />
      {trackedCommitSetBy && `${trackedCommitSetBy}.`}
      {trackedCommitIsOutdated && (
        <span className={styles.outdatedMessage}>
          Stack's tracked commit is not the one the HEAD pointer in blob storage names.
        </span>
      )}
    </>
  );

  const commitLabel = getCommitLabel(provider, trackedCommit.hash);

  return (
    <div className={styles.trackedCommitWrapper}>
      <TextEllipsis
        tooltip={
          <>
            {commitLabel}
            {commitDetails}
          </>
        }
        forceTooltipActive={!!commitDetails}
        tooltipWidthMode="maxWidthSm"
      >
        {(tooltipProps) => (
          <Typography
            {...tooltipProps}
            tag="span"
            variant="p-body3"
            className={cx(tooltipProps.className, styles.commit)}
          >
            {trackedCommitIsOutdated && <span className={styles.outdatedIndicator} />}
            {commitLabel}
          </Typography>
        )}
      </TextEllipsis>
    </div>
  );
};

export default StacksTableCommitCellBlobContent;
